import { config } from '@/config/config';
import { mapControlClassName } from '@/utils/map';
import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import classes from './back-to-previous-control.module.css';

export function BackToPreviousControl() {
  const getApplicationRoot = () => {
    const path = window.location.pathname.toLowerCase();

    if (path.startsWith('/oceans')) {
      return '/oceans';
    }

    if (path.startsWith('/expeditions')) {
      return '/expeditions';
    }

    return '/';
  };

  const applicationRoot = getApplicationRoot();

  const hasPreviousPage =
    window.history.length > 1 &&
    document.referrer &&
    new URL(document.referrer).hostname === window.location.hostname &&
    (window.location.pathname.replace(/\/+$/, '') || '/') !== applicationRoot;

  const handleClick = () => {
    if (hasPreviousPage) {
      window.history.back();
    } else {
      window.location.href = applicationRoot;
    }
  };

  const label = hasPreviousPage
    ? '< Back To Previous'
    : `Go To ${config.applicationName}`;

  return (
    <MapControl position={ControlPosition.TOP_LEFT}>
      <button
        type="button"
        className={`${mapControlClassName} ${classes.btnBack}`}
        onClick={handleClick}
      >
        {label}
      </button>
    </MapControl>
  );
}